import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import btoa from 'btoa';
import _ from 'lodash';
import { SignupLiteModal } from 'shared-components/flow-signup/signup-lite-modal';
import { EmailVerifyModal } from 'shared-components/flow-signup/email-verify-modal';
import { AvatarModal } from 'shared-components/flow-signup/avatar-modal';
import ModalManager from '../elements-modal/modal-manager';
import { updateProfile, createProfile, initAuth } from '../app-main/actions/auth';
import { checkGrants, createSession } from '../app-main/actions/session';
import RsvpAcceptModal from '../app-attendee-page/attendee-rsvp-accept-modal';
import RsvpDeclineModal from '../app-attendee-page/attendee-rsvp-decline-modal';
import ChangeRsvpModal from './change-rsvp-modal';
import { FormattedMessage } from 'react-intl';

class AttendeeModalContainer extends Component {
  constructor (props) {
    super(props);
    this.updateProfileAction = this.updateProfileAction.bind(this);
    this.updateProfileActionCb = this.updateProfileActionCb.bind(this);
    this.checkGrantsAction = this.checkGrantsAction.bind(this);
    this.signupAction = this.signupAction.bind(this);
    this.signupActionCb = this.signupActionCb.bind(this);
    this.signinAction = this.signinAction.bind(this);
    this.signinActionCb = this.signinActionCb.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.emailVerifyCb = this.emailVerifyCb.bind(this);
  }

  updateProfileAction (profileObj, callback) {
    const { dispatch } = this.props;

    dispatch(updateProfile(profileObj))
      .then(res => {
        const analyticsProps = {
          event: 'signup photo form submitted',
          booking: this.props.booking,
          currentStatus: this.props.rsvpStatus,
          dateModified: _.get(this.props, 'profile.data.date_modified'),
          userId:  _.get(this.props, 'profile.data.SSOid')
        };

        analyticsIntegrations.rsvpEvent(analyticsProps);

        callback(res);
      })
      .catch(err => {
        callback(err);
      });
  }

  updateProfileActionCb () {
    const isEmailVerified = _.get(this.props, ['profile', 'data', 'email_verified'], false);

    if (isEmailVerified) {
      return this.props.whichModalCb();
    }

    return this.props.toggleModal('emailVerifyModal', this.props.whichModalCb);
  }

  checkGrantsAction (username, profileBody, callback) {
    const { dispatch } = this.props;

    dispatch(checkGrants(username))
      .then(res => {
        callback(res, profileBody);
      })
      .catch(err => {
        callback(err, profileBody);
      });
  }

  signupAction (profileObj, callback) {
    const { dispatch } = this.props;

    dispatch(createProfile(profileObj))
      .then(res => {
        const { access_token: accessToken } = res;
        // Run initAuth in parrallel
        dispatch(initAuth(btoa(accessToken)));
        return res;
      })
      .then((profileRes) => {
        return callback(profileRes, profileObj);
      })
      .catch(err => {
        callback(err, profileObj);
      });
  }

  signupActionCb (profileRes, projectObj) {
    if (this.props.whichModalCb) {
      this.props.whichModalCb(true, profileRes, projectObj);
    }
  }

  signinAction (username, password, callback, profileDetails) {
    const { dispatch } = this.props;

    dispatch(createSession(username, password))
      .then(res => {
        const { access_token: accessToken } = res;
        // Run initAuth in parrallel
        dispatch(initAuth(btoa(accessToken)));
        return res;
      })
      .then(res => {
        if (profileDetails) {
          return dispatch(updateProfile(profileDetails))
            .then(newProfileDetails => {
              return Object.assign({}, res, newProfileDetails.profile);
            });
        }
        return res;
      })
      .then(res => {
        return callback(res);
      })
      .catch(err => {
        callback(err);
      });
  }

  signinActionCb () {
    if (this.props.whichModalCb) {
      this.props.whichModalCb();
    }
  }

  closeModal () {
    this.props.toggleModal('', null);
  }

  emailVerifyCb (verified) {
    if (verified) {
      const analyticsProps = {
        event: 'signup verify email form submitted',
        booking: this.props.booking,
        currentStatus: this.props.rsvpStatus
      };

      analyticsIntegrations.rsvpEvent(analyticsProps);
    }
    if (this.props.whichModalCb) {
      this.props.whichModalCb();
    }
  }

  render () {
    return (
      <ModalManager {...this.props}>
        <SignupLiteModal
          ref="signUpLiteModal"
          checkGrantsAction={this.checkGrantsAction}
          signupAction={this.signupAction}
          signupActionCb={this.signupActionCb}
          signinAction={this.signinAction}
          signinActionCb={this.signinActionCb}
          closeModal={this.closeModal}
          header={
            <h3>
              <FormattedMessage id="invite.attendee_modal_container.sign_up" defaultMessage="Sign up to RSVP" />
            </h3>
          }
        />

        <AvatarModal
          ref="avatarModal"
          updateProfile={this.updateProfileAction}
          updateProfileCb={this.updateProfileActionCb}
          closeModal={this.closeModal}
          skipAction={this.updateProfileActionCb}
          onClose={this.updateProfileActionCb}
          header={
            <h3>
              <FormattedMessage
                id="invite.attendee_modal_container.add_photo"
                defaultMessage="Add a photo so {name} knows who’s coming"
                values={{
                  name: this.props.guestFirstName
                }}
              />
            </h3>
          }
        />

        <EmailVerifyModal
          ref="emailVerifyModal"
          emailVerifyCb={() => this.emailVerifyCb(true) }
          onClose={this.emailVerifyCb}
        />

        <RsvpAcceptModal
          ref="rsvpAcceptModal"
          closeModal={this.closeModal}
          booking={this.props.booking}
        />

        <RsvpDeclineModal
          ref="rsvpDeclineModal"
          closeModal={this.closeModal}
          guestFirstName={this.props.guestFirstName}
        />

        <ChangeRsvpModal
          ref="changeRsvpModal"
          handleChangeResponseModal={this.props.handleChangeResponseModal}
          guestFirstName={this.props.guestFirstName}
        />
      </ModalManager>
    );
  }
}

AttendeeModalContainer.propTypes = {
  dispatch: PropTypes.func,
  guestFirstName: PropTypes.string,
  booking: PropTypes.object,
  handleChangeResponseModal: PropTypes.func,
  whichModalCb: PropTypes.func,
  rsvpStatus: PropTypes.string
};

function mapStateToProps (state) {
  const { auth, profile, entities } = state;
  const { accessToken } = auth;
  const { SSOid } = profile;

  return {
    auth,
    profile,
    SSOid,
    accessToken,
    entities
  };
}

export default connect(mapStateToProps)(AttendeeModalContainer);
